module.exports = __webpack_public_path__ + "img/2.45aaa2fa.svg";